<template>
  <div>
    <v-simple-table fixed-header>
      <template v-slot:default>
        <thead>
          <tr>
            <th :colspan="2" class="grey lighten-1 font-weight-bold subtitle-1">
              {{ $t("detail-user-title") }}
            </th>
          </tr>
        </thead>
        <tbody>
          <!-- username -->
          <!-- <tr>
            <td>
              <strong>{{ $t("user-id-title") }}</strong>
            </td>
            <td>{{ profileUser.username }}</td>
          </tr> -->

          <!-- email -->
          <tr>
            <td>
              <strong>{{ $t("email-address-title") }}</strong>
            </td>
            <td>{{ profileUser.email }}</td>
          </tr>

          <!-- ticket -->
          <tr>
            <td>
              <strong>{{ $t("ticket-action-title") }}</strong>
            </td>
            <td>
              <div class="d-flex">
                <span v-if="!statusEditTicket">{{ profileUser.ticket }}</span>
                <v-text-field
                  v-if="statusEditTicket"
                  :value="profileUser.ticket"
                  :min="0"
                  :key="keyTicket"
                  hide-details
                  class="max-width-1"
                  @input="changeValueTicket"
                  outlined
                  autofocus
                  dense
                />
                <v-spacer />
                <v-icon
                  v-if="!statusEditTicket"
                  @click="statusEditTicket = true"
                  >mdi-pencil</v-icon
                >
                <v-icon v-else @click="handleUpdaleTicket">mdi-check</v-icon>
              </div>
            </td>
          </tr>

          <!-- Activity log -->
          <tr>
            <td>
              <strong>{{ $t("activity-log-title") }}</strong>
            </td>
            <td>
              <router-link
                :to="{
                  name: 'Activity log user',
                  params: {
                    id: profileUser.Id,
                    
                  },
                  query: {username: profileUser.nickname ? profileUser.nickname : profileUser.email,email:profileUser.email }
                }"
                >{{ $t("activity-log-title") }}</router-link
              >
            </td>
          </tr>

          <!-- Lesson count -->
          <tr>
            <td>
              <strong>{{ $t("lesson-count-title") }}</strong>
            </td>
            <td>{{ profileUser.lesson_count }}</td>
          </tr>

          <!-- Lesson cancel -->
          <tr>
            <td>
              <strong>{{ $t("lesson-count-cancel-title") }}</strong>
            </td>
            <td>{{ profileUser.lesson_cancel_count }}</td>
          </tr>

          <!-- Active-->
          <tr>
            <td>
              <strong>{{ $t("approve-title") }}</strong>
            </td>
            <td>
              <div class="d-flex">
                <v-chip
                  small
                  v-if="profileUser.active !== ''"
                  :color="profileUser.active ? 'success' : 'default'"
                  class="text-capitalize font-weight-medium"
                  style="min-width: 94px; justify-content: center"
                  >{{
                    profileUser.active
                      ? $t("active-title")
                      : $t("inactive-title")
                  }}</v-chip
                >
                <v-spacer />
                <v-btn
                  small
                  color="error"
                  v-if="profileUser.active"
                  @click="dialogConfirmBANUser = true"
                  >BAN</v-btn
                >
              </div>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-row class="mx-1 my-2">
      <v-spacer />
      <v-btn @click.prevent="goBack">戻る</v-btn>
    </v-row>
    <!-- dialog confirm ban user  -->
    <v-dialog v-model="dialogConfirmBANUser" width="380">
      <v-card>
        <v-card-title class="headline grey lighten-2 py-2">確認</v-card-title>

        <v-card-text class="mt-2">{{
          $t("ban-conten", { name: profileUser.email })
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            color="error"
            :loading="loaddingBANUser"
            @click="handleBANUser"
            >OK</v-btn
          >
          <v-btn small color @click="dialogConfirmBANUser = false"
            >キャンセル</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import mixin from "@/mixin";
import { getProfileUser, updateUser, banUser } from "@/api/User.api";
export default {
  mixins: [mixin.Auth],
  data() {
    return {
      profileUser: {},
      statusEditTicket: false,
      keyTicket: 0,
      dialogConfirmBANUser: false,
      loaddingBANUser: false,
    };
  },
  async created() {
    await this.handleGetProfileUser();
  },
  methods: {
    async handleGetProfileUser() {
      let params = {
        username: this.$route.params.username,
      };
      await getProfileUser(params).then((res) => {
        this.profileUser = res.result;
      });
    },
    changeValueTicket(e) {
      let regex = /[^0-9]/g;
      if (!regex.test(e)) {
        this.profileUser.ticket = Number(e);
      } else {
        this.keyTicket++;
      }
    },
    goBack () {
       this.$router.push({name: 'List User'})
    },
    async handleUpdaleTicket() {
      const { username, Id, ticket } = this.profileUser;
      let params = {
        username,
        user_id: Id,
        ticket,
      };
      await updateUser(params)
        .then(() => {
          this.statusEditTicket = false;
          this.handleGetProfileUser();
        })
        .catch((err) => {
          this.$toast.error(err);
        });
    },
    async handleBANUser() {
      this.loaddingBANUser = true;
      const { username, Id } = this.profileUser;
      await this.handleDisableUser(username)
        .then(async () => {
          let params = {
            username,
            user_id: Id,
          };
          await banUser(params)
            .then(() => {
              this.dialogConfirmBANUser = false;
              this.handleGetProfileUser();
            })
            .catch((error) => {
              if (error.response.data.result.error == "update error") {
                this.$toast.error("アカウントはBANされている。");
                this.dialogConfirmBANUser = false;
                this.handleGetProfileUser();
              } else {
                this.$toast.error(error);
              }
              this.loaddingBANUser = false;
            });
        })
        .catch((error) => {
          this.$toast.error(error);
          this.loaddingBANUser = false;
        });
      this.loaddingBANUser = false;
    },
  },
};
</script>
<style scoped>
::v-deep .v-data-table__wrapper {
  border: 1px solid #dcdcdc;
}
</style>
<style lang="scss" scoped>
tr td:first-child {
  border-right: 1px solid #ccc;
}
</style>